import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'
import TextCopy from './TextCopy'

const RecordId = ({ record, labelPrefix, valuePrefix, ...props }) => {
  const { t } = useTranslation('common')
  const canSeeId = useSessionPermission('seeRecordIds')
  if (!canSeeId) return false

  const idLabel = labelPrefix || t('id')
  return (
    <>
      <TextCopy
        label={`${idLabel}: ${record?.id}`}
        value={`${valuePrefix || ''}${record?.id}`}
        size="xxsmall"
        {...props}
      />
    </>
  )
}

export default RecordId
